import { createSelector } from "reselect";
import { get } from "lodash";

const localeQuery = state => get(state, "locale.locale", null);
const fallbackQuery = state => get(state, "locale.locales.fallback", null);
const loadedQuery = state => {
  const locale = get(state, "locale.locale", null);
  if (!locale) return null;
  return get(state, `locale.locales.${locale}`, null);
};

export const selectCopy = createSelector(
  [localeQuery, loadedQuery, fallbackQuery],
  (locale, loaded, fallback) => (key, parseHTML) => {
    const loadedCopy = get(loaded, key);
    if (loadedCopy !== undefined) {
      // need to implament XSS safe implementation of parseHTML
      return loadedCopy;
    }

    const fallbackCopy = get(fallback, key);
    if (fallbackCopy) {
      console.warn(
        `LOCALE WARNING: [${locale}] '${key}' is using fallback copy.`
      );
      // need to implament XSS safe implementation of parseHTML
      return fallbackCopy;
    }

    console.error(`LOCALE ERROR: [${locale}] '${key}' copy not found!`);
    return "";
  }
);

// using the following export pattern so we can mock more easily using jest

const copySelector = {
  localeQuery,
  fallbackQuery,
  loadedQuery,
  selectCopy
};

export default copySelector;
